import { render, staticRenderFns } from "./daili.vue?vue&type=template&id=24c8528c&scoped=true"
import script from "./daili.vue?vue&type=script&lang=js"
export * from "./daili.vue?vue&type=script&lang=js"
import style0 from "./daili.vue?vue&type=style&index=0&id=24c8528c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8528c",
  null
  
)

export default component.exports